import { render, staticRenderFns } from "./HighRiskCorpratePopup.vue?vue&type=template&id=288e9232&scoped=true"
import script from "./HighRiskCorpratePopup.vue?vue&type=script&lang=js"
export * from "./HighRiskCorpratePopup.vue?vue&type=script&lang=js"
import style0 from "./HighRiskCorpratePopup.vue?vue&type=style&index=0&id=288e9232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288e9232",
  null
  
)

export default component.exports